import React from 'react';
import { OrderJobTask } from '../../../redux/slices/slice_types';
import { Tooltip, darken } from '@mui/material';
import styled from '@emotion/styled';
import PolarisIcon from '../PolarisIcon';
import AccuratePlayerIcon from '@/assets/images/accurate_player.png';
import { selectUser } from '../../../redux/selectors/authSelectors';
import { useAppSelector } from '@/redux/hooks';

interface TaskAccurateLinkProps {
  task: OrderJobTask;
}

const TaskAccurateLink = ({ task }: TaskAccurateLinkProps) => {
  const currentUser = useAppSelector(selectUser);
  const isMe = task?.assigned_user?.id === currentUser?.id;
  const url = task?.task_action?.action_url;
  const tooltipMsg = !url ? 'No Accurate Player URL found' : !isMe ? 'Task not assigned to you' : 'Launch Accurate Player';

  return (
    <Tooltip title={tooltipMsg} placement="left" arrow>
      <div>
        <AccuratePlayerButton href={url} target="_blank" rel="noreferrer" disabled={!url || !isMe}>
          <PolarisIcon icon="external_link" height={20} />
          <img src={AccuratePlayerIcon} alt="Accurate Player" style={{ width: 18, height: 18 }} />
        </AccuratePlayerButton>
      </div>
    </Tooltip>
  );
};

export default TaskAccurateLink;

const AccuratePlayerButton = styled.a<{ disabled?: boolean }>`
  background: ${({ theme }) => darken(theme.palette.background.default, 0.05)};
  border: 1px solid ${({ theme }) => (theme.palette.mode === 'dark' ? theme.palette.divider : 'transparent')};
  padding: 7px;
  padding-left: 7px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  display: inline-flex;

  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.33;
    &:hover > svg {
      display: none;
    }
  `}

  > svg {
    position: absolute;
    right: -10px;
    top: -10px;
    background: ${({ theme }) => theme.palette.background.default};
    padding: 3px;
    opacity: 0;
    transition: opacity 0.3s;
    border-radius: 50%;
    color: ${({ theme }) => theme.palette.text.primary};
  }

  &:hover {
    background: ${({ theme }) => darken(theme.palette.background.default, 0.06)};
    > svg {
      opacity: 0.8;
      transition: opacity 0.3s;
    }
  }
`;
